// extracted by mini-css-extract-plugin
module.exports = {"bannerSlider":"vo3L5","noMarginTop":"lF5rz","sliderBlk":"YNj7r","fakeLink":"aIb0Y"};